import {
  Box,
  Heading,
  Text,
  Image,
  Flex,
  Icon,
  Link,
  SimpleGrid,
} from "@chakra-ui/react";
import { IoMdClose } from "react-icons/io";

import Logo from "../assets/images/logo.png";
import AppStore from "../assets/images/appStore.png";
import PlayStore from "../assets/images/playStore.png";
import Intro from "../assets/images/intro.gif";

export const Welcome = () => {
  return (
    <Box>
      <SimpleGrid columns={{ base: 1, md: 2 }}>
        <Flex
          // bg={"radial-gradient(circle, #FFF7F3, #D8F1F2)"}
          bg={"linear-gradient(to bottom right, #FFF7F3, #D8F1F2)"}
          h={{ base: "auto", md: "100vh" }}
          borderBottomLeftRadius={{ base: 24, md: 0 }}
          borderBottomRightRadius={{ base: 24, md: 0 }}
          px={{ base: "24px", md: "10%" }}
          pt={{ base: "24px", md: 0 }}
          flexDir={"column"}
          justify={"center"}
        >
          <Flex
            justifyContent={"flex-end"}
            mb={"16px"}
            display={{ base: "flex", md: "none" }}
          >
            <Icon fontSize={24} color={"#19202D"}>
              <IoMdClose />
            </Icon>
          </Flex>

          <Flex justify={"center"} mb="32px">
            <Image
              src={Logo}
              alt="bookd-logo"
              h={{ base: "32px", md: "48px" }}
              objectFit={"contain"}
            />
          </Flex>

          <Box mb="32px">
            <Heading
              color={"#19202D"}
              fontSize={{ base: "18px", md: "32px" }}
              textAlign={"center"}
              px="30px"
              fontFamily={"RedHatDisplay-Bold"}
            >
              Book-d is best experienced using our mobile app.
            </Heading>

            <Text
              color={"#4F4F51"}
              fontSize={{ base: "14px", md: "20px" }}
              textAlign={"center"}
              mt={"7px"}
            >
              Unlock all features on the app.
            </Text>
          </Box>

          <Flex justify={"center"} mb="12px" gap={"20px"}>
            <Link
              href="https://apps.apple.com/us/app/bookd-pro/id6503949063"
              target="_blank"
            >
              <Image src={AppStore} alt="bookd-appstore" h={"40px"} w="138px" />
            </Link>

            <Link
              href="https://play.google.com/store/apps/details?id=com.book_d&pcampaignid=web_share"
              target="_blank"
            >
              <Image
                src={PlayStore}
                alt="bookd-playstore"
                h={"40px"}
                w="138px"
              />
            </Link>
          </Flex>

          <Flex
            justify={"center"}
            overflow={"hidden"}
            h={"350px"}
            display={{ base: "flex", md: "none" }}
          >
            <Image
              src={Intro}
              alt="bookd-intro"
              h={"150%"}
              objectFit={"cover"}
            />
          </Flex>
        </Flex>

        <Flex
          justify={"center"}
          align={"center"}
          h={"100%"}
          display={{ base: "none", md: "flex" }}
        >
          <Image src={Intro} alt="bookd-intro" objectFit={"cover"} />
        </Flex>
      </SimpleGrid>
    </Box>
  );
};
